/**
 * Class handling logs
 */

class AppConsoleService {

  print(jsObj) {
    console.log(jsObj)
  }

  log(level, module, message) {
    switch (level) {
      case 'ERROR':
        console.error(level+ ' | '+ module+ ' | '+ message)
        break
      default :
        console.log(level+ ' | '+ module+ ' | '+ message)
        break
    }

  }

  info(module, message) {
    this.log('INFO', module, message)
  }

  warn(module, message) {
    this.log('WARN', module, message)
  }

  debug(module, message) {
    this.log('DEBUG', module, message)
  }

  error(module, error) {
    // Réponse sans corps (502 de passerelle…) ou erreur nulle : pas de plantage du journal
    let message =
      error?.response?.data?.message ||
      error?.message ||
      String(error);
    this.log('ERROR', module, message)
  }


}

export default new AppConsoleService();
